import React, { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDragHandler } from '../../../utils/useDragHandler';
import * as THREE from 'three';
import { createSingleSocket } from '../../../factory/symbols/createSocketSymbols';
import { setCommandType, setCommandMessage, setOperationData } from '../../../redux/operationSlice';
import { clearSelection } from '../../../redux/selectionSlice';
import { COMMANDS } from '../../../utils/commonProperties';
// eslint-disable-next-line no-restricted-imports -- CSS paylaşımlı, components/TypeMenus/'ta kaldı
import '../../../components/TypeMenus/PanelTypeMenus.css';

export default function SocketTypeMenu({
  x,
  y,
  onClose,
  details = {}, // Expecting { id: ... } inside details or passed separately
  onUpdateDetails,
  scene,
  onDrag
}) {
  const menuRef = useRef(null);
  const dispatch = useDispatch();
  const { handleMouseDown } = useDragHandler(onDrag);

  // Find the socket object in the scene to get current state
  let socketObj;
  let socketUserData;

  if (scene && details.id) {
    scene.traverse(obj => {
      if (obj.userData.id === details.id) {
        socketObj = obj;
        socketUserData = obj.userData;
      }
    });
  }

  const [localDetails, setLocalDetails] = useState({
    socketType: socketUserData ? socketUserData.subtype : (details.socketType || 'normal'),
    power: socketUserData ? socketUserData.power : (details.power || 300),
  });

  useEffect(() => {
    if (socketUserData) {
      setLocalDetails({
        socketType: socketUserData.subtype || 'normal',
        power: socketUserData.power || 300
      });
    }
  }, [socketUserData]);

  const handleMouseDownWithStop = (e) => {
    e.stopPropagation();
    handleMouseDown(e, menuRef);
  };

  const handleTypeChange = (newType) => {
    setLocalDetails(prev => ({ ...prev, socketType: newType }));

    if (!socketObj || !scene) return;

    const oldSocket = socketObj;
    const {
      id,
      basePoint,
      tempLineUUID,
      power,
      stretchLength
    } = oldSocket.userData;

    // Mevcut TOPLAM rotasyonu al. offsetGroup.rotation.z = wireAngle + userRotate
    // (radyan). Yeni mesh dir=null ile yaratıldığında factory sadece currentRotate'i
    // uygular → toplam görsel açı korunur. userData.rotate sadece userRotate'i
    // tutar; tek başına kullanılırsa wire yönü kaybolur.
    let currentRotate;
    const oldOffsetGroup = oldSocket.children?.find(c => c.userData?.isOffsetGroup === true);
    if (oldOffsetGroup) {
      currentRotate = (oldOffsetGroup.rotation.z * 180) / Math.PI;
    } else if (oldSocket.userData.rotate !== undefined && oldSocket.userData.rotate !== null) {
      currentRotate = oldSocket.userData.rotate;
    } else {
      currentRotate = (oldSocket.rotation.z * 180) / Math.PI;
    }

    // ✅ Bağlı wire'dan rengi al (öncelikli)
    let existingColor = 0x0045ff;
    let foundColor = false;

    // Önce bağlı wire'ı bul ve onun rengini al
    scene.traverse((obj) => {
      if (foundColor) return;
      if (obj.isLine &&
          obj.userData?.sockets?.includes(id)) {
        if (obj.material && obj.material.color) {
          existingColor = obj.material.color.getHex();
          foundColor = true;
        }
      }
    });

    // Wire bulunamazsa socket'in kendi rengini kullan (fallback)
    if (!foundColor) {
      oldSocket.traverse((child) => {
        if (foundColor) return;
        if (child.userData && (child.userData.role === 'line1' || child.userData.role === 'line2' || child.userData.role === 'line3')) {
          if (child.material && child.material.color) {
            existingColor = child.material.color.getHex();
            foundColor = true;
          }
        }
      });
    }

    // Remove old socket. Y kayma fix'inden sonra socket fpMesh-child olabilir;
    // scene.remove() sadece direkt scene-child'ları kaldırır → no-op olur ve eski
    // mesh fpMesh altında sahnede kalırdı. removeFromParent her durumda ayırır.
    oldSocket.removeFromParent();
    oldSocket.traverse(child => {
      if (child.geometry) child.geometry.dispose();
      if (child.material) child.material.dispose();
    });

    // Create new socket
    const newSocket = createSingleSocket(
      scene,
      new THREE.Vector3(basePoint.x, basePoint.y, 0),
      null, // dir
      existingColor, // Use extracted color
      false,
      newType,
      tempLineUUID,
      currentRotate,
      id,
      stretchLength
    );

    // ✅ Yeni socket'i sahneye ekle
    scene.add(newSocket);

    // Restore userData
    newSocket.userData.id = id;
    newSocket.userData.basePoint = basePoint;
    newSocket.userData.tempLineUUID = tempLineUUID;
    newSocket.userData.power = power; // Keep existing power
    newSocket.userData.rotate = currentRotate;
    newSocket.userData.stretchLength = stretchLength;

    // ✅ createSingleSocket zaten rotasyonu uyguluyor, tekrar uygulamaya gerek yok

    if (onUpdateDetails) {
      onUpdateDetails({ ...localDetails, socketType: newType });
    }
  };

  const handlePowerChange = (newPower) => {
    setLocalDetails(prev => ({ ...prev, power: newPower }));
    
    if (socketObj) {
      socketObj.userData.power = newPower;
    }

    if (onUpdateDetails) {
      onUpdateDetails({ ...localDetails, power: newPower });
    }
  };

  return (
    <div
      ref={menuRef}
      className="panel-type-menu"
      style={{ left: x, top: y }}
    >
      <div
        onMouseDown={handleMouseDownWithStop}
        className="panel-type-menu-header"
      >
        Priz Detay
        <button
          className="close-button"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          ×
        </button>
      </div>
      <div className="panel-type-options">
        <div className="panel-type-details-box">
          <table className="panel-type-details-table">
            <tbody>
              <tr>
                <td className="td">Tip</td>
                <td>
                  <select
                    style={{
                      width: "100%",
                      maxWidth: "160px",
                      backgroundColor: '#333',
                      color: '#eee',
                      border: '1px solid #555',
                      borderRadius: '4px',
                      padding: '2px'
                    }}
                    value={localDetails.socketType}
                    onChange={(e) => handleTypeChange(e.target.value)}
                  >
                    <option value="normal">Normal</option>
                    <option value="etanj">Etanj</option>
                    <option value="kapaklı">Kapaklı</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td className="td">Güç (W)</td>
                <td>
                  <select
                    style={{
                      width: "100%",
                      maxWidth: "160px",
                      backgroundColor: '#333',
                      color: '#eee',
                      border: '1px solid #555',
                      borderRadius: '4px',
                      padding: '2px'
                    }}
                    value={localDetails.power}
                    onChange={(e) => handlePowerChange(Number(e.target.value))}
                  >
                    <option value={300}>300W</option>
                    <option value={600}>600W</option>
                    <option value={1000}>1000W</option>
                    <option value={1500}>1500W</option>
                    <option value={2000}>2000W</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="panel-type-buttons">
            <button
                className="my-button"
                onClick={() => {
                    if (socketObj) {
                        // ✅ Socket'in bağlı olduğu wire'ı bul
                        let parentWire = null;
                        scene.traverse(obj => {
                            if (obj.isLine &&
                                obj.userData?.sockets &&
                                obj.userData.sockets.includes(socketObj.userData?.id)) {
                                parentWire = obj;
                            }
                        });

                        // ✅ Socket pozisyonundaki buat'ı bul (varsa).
                        // Buat yoksa (zincirin son prizi → buat oluşmamış) socket pozisyonunu
                        // başlangıç noktası olarak kullan; useSocket buat'ı otomatik oluşturur.
                        const socketWorldPos = new THREE.Vector3();
                        socketObj.getWorldPosition(socketWorldPos);
                        let buatObj = null;

                        scene.traverse(obj => {
                            if (obj.userData?.type === 'socketBuat') {
                                const bWorld = new THREE.Vector3();
                                obj.getWorldPosition(bWorld);
                                const distance = Math.sqrt(
                                    Math.pow(bWorld.x - socketWorldPos.x, 2) +
                                    Math.pow(bWorld.y - socketWorldPos.y, 2)
                                );
                                // 1 birimden yakınsa bu buat'tır
                                if (distance < 1) {
                                    buatObj = obj;
                                }
                            }
                        });

                        const startPosition = buatObj
                            ? (() => { const wp = new THREE.Vector3(); buatObj.getWorldPosition(wp); return { x: wp.x, y: wp.y, z: wp.z }; })()
                            : { x: socketWorldPos.x, y: socketWorldPos.y, z: socketWorldPos.z || 0 };

                        // ✅ Source bilgisini hazırla — buat varsa onun userData'sını,
                        // yoksa parentWire/socketObj'den oku.
                        const panelID = parentWire?.userData?.panelID || buatObj?.userData?.panelID || socketObj?.userData?.panelID;
                        const socketLoadId = parentWire?.userData?.socketLoadId || buatObj?.userData?.socketLoadId || socketObj?.userData?.socketLoadId;
                        const wireID = parentWire?.userData?.id || buatObj?.userData?.wireID || socketObj?.userData?.wireID;

                        const sourceData = {
                            type: 'socketBuat',
                            panelID,
                            socketLoadId,
                            wireID,
                            userData: { panelID, socketLoadId, wireID }
                        };

                        dispatch(clearSelection());
                        dispatch(setCommandType(COMMANDS.DRAW_SOCKET));
                        dispatch(setCommandMessage(buatObj
                            ? "Buat'tan priz hattı başlatıldı. Sonraki noktaları seçin"
                            : "Priz konumundan yeni hat başlatıldı. Sonraki noktaları seçin"));
                        dispatch(setOperationData({
                            autoSelectBuat: {
                                buatId: buatObj?.userData?.id || null,
                                position: startPosition
                            },
                            source: sourceData
                        }));
                        onClose();
                    }
                }}
            >
                Yeni Priz Hattı Ekle
            </button>
        </div>
      </div>
    </div>
  );
}
